import Vue from 'vue'
import App from './App.vue'

import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';
import './styles/index.scss';

import router from './router';
Vue.prototype.$apiBaseUrl = 'https://app.91naruan.com';
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
